<div class="steps-wrap">
  <ng-container *ngFor="let step of steps; index as i">
    <div class="step" [ngClass]="getClass(i)">
      <div class="icon"><fa-icon icon="check"></fa-icon><fa-icon icon="ellipsis-h"></fa-icon></div>
      <div class="text">{{step}}</div>
    </div>
    <div class="line"></div>
  </ng-container>
</div>
